import { ProfilePasswordComponent } from './profile-password/profile-password.component';
import { ProfileListComponent } from './profile-list/profile-list.component';
export var profileRoutes = [
    {
        path: 'profile',
        data: {
            'expectedRoles': ['Admin', 'IT', 'Accountant', 'Accountant Admin', 'UIH', 'Operation']
        },
        children: [
            {
                path: 'password',
                component: ProfilePasswordComponent,
                data: {
                    'expectedRoles': ['Admin', 'IT', 'Accountant', 'Accountant Admin', 'UIH', 'Operation']
                },
            },
            {
                path: 'list',
                component: ProfileListComponent,
                data: {
                    'expectedRoles': ['Admin', 'IT']
                },
            }
        ],
    }
];
var ProfileRoutingModule = (function () {
    function ProfileRoutingModule() {
    }
    return ProfileRoutingModule;
}());
export { ProfileRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-routing.module.ts.pre-build-optimizer.js